import { UrlType } from 'src/app/shared/enum/url-type';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
var IconPanelComponent = /** @class */ (function () {
    function IconPanelComponent() {
        this.urlType = UrlType;
    }
    Object.defineProperty(IconPanelComponent.prototype, "hostClasses", {
        get: function () { return resolveThemeCssClass(this.data.panelSettings); },
        enumerable: true,
        configurable: true
    });
    return IconPanelComponent;
}());
export { IconPanelComponent };
